module.exports = __webpack_public_path__ + "static/img/no_data.81f843b6.png";